__turbopack_context__.v({
  "className": "geist_d5956f67-module__L54rSq__className",
  "variable": "geist_d5956f67-module__L54rSq__variable",
});
